import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { SearchCustomers, SearchCustomersVariables } from '@/graphql/contracts/_generated_/searchCustomers.query';
import SearchCustomerQuery from '@/graphql/contracts/searchCustomers.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useSearchCustomers() {
  const [_searchCustomers, { loading, data }] = useLazyQuery<SearchCustomers, SearchCustomersVariables>(
    SearchCustomerQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const searchCustomers = async (text: string) => {
    var customers = await _searchCustomers({
      variables: {
        searchString: text
      }
    });
    return customers?.data?.searchContractsAndCustomers?.customers ?? [];
  };

  return {
    searchCustomers,
    isSearchLoading: loading,
    searchCustomersData: data?.searchContractsAndCustomers?.customers ?? []
  } as const;
}
